import { default as _91slug_93HI4nIfCJx5Meta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/tourleader/[id]/[slug].vue?macro=true";
import { default as _91slug_93XJEXeJAG2HMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/titinerary/[slug].vue?macro=true";
import { default as _91name_93m02FxasUtmMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/shipinfo/[name].vue?macro=true";
import { default as _91paxid_93vCHV09yfWRMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/satisfactionstatus/[triptypeid]/[paxid].vue?macro=true";
import { default as _91id_93XY0rYVMQBfMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/payment/[id].vue?macro=true";
import { default as _91id_93gjUwSRSHOaMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/omdome/[id].vue?macro=true";
import { default as _91tab_93JFYpyAEIXtMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/mytrip/[tab].vue?macro=true";
import { default as _91tab_93wQkEy2JAj1Meta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/solo/[tab].vue?macro=true";
import { default as _91tab_93Pqg5wr57MCMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/lectures/[tab].vue?macro=true";
import { default as _91tab_93B0WEd3tVnHMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/connections/[tab].vue?macro=true";
import { default as _91tab_9355XpllFOE3Meta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/about/[tab].vue?macro=true";
import { default as _91slug_93e60eHiUMMRMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/info/[slug].vue?macro=true";
import { default as _91id_93q1MCICwHt0Meta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/fn/[id].vue?macro=true";
import { default as _91tab_93wwIUy3JbrsMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/destination/[slug]/[tab].vue?macro=true";
import { default as _91slug_93JlZlkUdllEMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/competition/[slug].vue?macro=true";
import { default as _91slug_93moXUMlBaU2Meta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/category/[slug].vue?macro=true";
import { default as _91ocr_93WaX7ibKBPeMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/bookingfaq/[ocr].vue?macro=true";
import { default as _91ocr_93p8Sn3PVrEZMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/booking-finish/[ocr].vue?macro=true";
import { default as _91id_93F2yRPthUhIMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/booking-confirmation/[id].vue?macro=true";
import { default as _91tripid_93e04oQK6CrKMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/bookflight/[tripid].vue?macro=true";
import { default as _91step_93dUyj1TUjIEMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/book/[tripid]/[step].vue?macro=true";
import { default as _91slug_93baWbbrGuO1Meta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/auth/[slug].vue?macro=true";
import { default as _91jwt_932xyfhX4bz8Meta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/app/l/[jwt].vue?macro=true";
import { default as _91tab_93vXbWh9YVH1Meta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/[triptype]/[slug]/[tab].vue?macro=true";
import { default as indexbApdPCv5MfMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/app/index.vue?macro=true";
import { default as callbackKV8O4DnNBsMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/auth/callback.vue?macro=true";
import { default as blackweekx3hdHeC2ycMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/blackweek.vue?macro=true";
import { default as _91slug_93kxOSVmJW6UMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/blog/[slug].vue?macro=true";
import { default as indexkzBQeA4qtZMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/blog/index.vue?macro=true";
import { default as bookcallpIHEPsV7ReMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/bookcall.vue?macro=true";
import { default as byebyeie3Fdt6uzhRgMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/byebyeie.vue?macro=true";
import { default as indexmzQv580cwoMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/calendar/index.vue?macro=true";
import { default as lastminuteLgZHHdjwhcMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/calendar/lastminute.vue?macro=true";
import { default as _91name_93mYQM6vYraUMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/campaign/[name].vue?macro=true";
import { default as indexFKI3zITlNSMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/campaign/index.vue?macro=true";
import { default as catalogueRdIMytopr5Meta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/catalogue.vue?macro=true";
import { default as complaintIRa0XBmJG5Meta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/complaint.vue?macro=true";
import { default as dinbokning_45aktuellolqF8eK50EMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/dinbokning-aktuell.vue?macro=true";
import { default as _91slug_93H1Ost2kbTFMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/event/[slug].vue?macro=true";
import { default as index1mSIjJ7hTsMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/event/index.vue?macro=true";
import { default as faqJdf1V3ElKaMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/faq.vue?macro=true";
import { default as _91id_93UTTo4vp2BXMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/giftcard/[id].vue?macro=true";
import { default as indexwOizsQkRtMMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/giftcard/index.vue?macro=true";
import { default as _91name_934FUURTHQvSMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/hotels/[name].vue?macro=true";
import { default as index7COfWnPpoeMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/hotels/index.vue?macro=true";
import { default as indexeI4onXbps4Meta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/index.vue?macro=true";
import { default as grouptravelsMgHf60jnpMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/grouptravel.vue?macro=true";
import { default as indexgSSJ6h7ELfMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/index.vue?macro=true";
import { default as reviewsDe2U6NVDBTMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/reviews.vue?macro=true";
import { default as lastminute2I060upi4BMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/lastminute.vue?macro=true";
import { default as mapy6yN56x8G3Meta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/map.vue?macro=true";
import { default as dinbokningzVchMnFV2KMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/mytrip/dinbokning.vue?macro=true";
import { default as newsletter4hRVZoSdETMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/newsletter.vue?macro=true";
import { default as offlinebLwIHZOEsyMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/offline.vue?macro=true";
import { default as failedLPsQCTXFdlMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/payment/failed.vue?macro=true";
import { default as indexJXCEQxEbdeMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/review/index.vue?macro=true";
import { default as searchujrV8LhsT5Meta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/search.vue?macro=true";
import { default as indexPFJpN2aCdZMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/tourleader/index.vue?macro=true";
import { default as verification_45doneisG3nlnX1DMeta } from "/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/verification-done.vue?macro=true";
export default [
  {
    name: "tourleader-id",
    path: "/reseledare/:id()",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/tourleader/[id]/[slug].vue")
  },
  {
    name: "titinerary",
    path: "/dagprogram",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/titinerary/[slug].vue")
  },
  {
    name: "shipinfo",
    path: "/fartyg",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/shipinfo/[name].vue")
  },
  {
    name: "satisfactionstatus-triptypeid",
    path: "/nojdhet-status/:triptypeid()",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/satisfactionstatus/[triptypeid]/[paxid].vue")
  },
  {
    name: "payment",
    path: "/payment",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/payment/[id].vue")
  },
  {
    name: "omdome",
    path: "/omdome",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/omdome/[id].vue")
  },
  {
    name: "mytrip",
    path: "/dinresa",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/mytrip/[tab].vue")
  },
  {
    name: "info-solo",
    path: "/info/solo",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/solo/[tab].vue")
  },
  {
    name: "info-lectures",
    path: "/info/forelasningar",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/lectures/[tab].vue")
  },
  {
    name: "info-connections",
    path: "/info/anslutning",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/connections/[tab].vue")
  },
  {
    name: "info-about",
    path: "/info/om",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/about/[tab].vue")
  },
  {
    name: "info",
    path: "/info",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/info/[slug].vue")
  },
  {
    name: "fn",
    path: "/fn",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/fn/[id].vue")
  },
  {
    name: "destination-slug",
    path: "/destination/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/destination/[slug]/[tab].vue")
  },
  {
    name: "competition",
    path: "/tavling",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/competition/[slug].vue")
  },
  {
    name: "category",
    path: "/kategori",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/category/[slug].vue")
  },
  {
    name: "bookingfaq",
    path: "/boknings-faq",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/bookingfaq/[ocr].vue")
  },
  {
    name: "booking-finish",
    path: "/booking-finish",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/booking-finish/[ocr].vue")
  },
  {
    name: "booking-confirmation",
    path: "/booking-confirmation",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/booking-confirmation/[id].vue")
  },
  {
    name: "bookflight",
    path: "/boka-flyg",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/bookflight/[tripid].vue")
  },
  {
    name: "book-tripid",
    path: "/boka/:tripid()",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/book/[tripid]/[step].vue")
  },
  {
    name: "auth",
    path: "/medlem",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/auth/[slug].vue")
  },
  {
    name: "app-l",
    path: "/app/l",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/app/l/[jwt].vue")
  },
  {
    name: "triptype-slug",
    path: "/:triptype()/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/[triptype]/[slug]/[tab].vue")
  },
  {
    name: "triptype-slug-tab",
    path: "/:triptype()/:slug()/:tab()",
    meta: _91tab_93vXbWh9YVH1Meta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/[triptype]/[slug]/[tab].vue")
  },
  {
    name: "app",
    path: "/app",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/app/index.vue")
  },
  {
    name: "app-l-jwt",
    path: "/app/l/:jwt()",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/app/l/[jwt].vue")
  },
  {
    name: "auth-slug",
    path: "/medlem/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/auth/[slug].vue")
  },
  {
    name: "auth-callback",
    path: "/medlem/callback",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/auth/callback.vue")
  },
  {
    name: "blackweek",
    path: "/blackweek",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/blackweek.vue")
  },
  {
    name: "blog-slug",
    path: "/blogg/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/blog/[slug].vue")
  },
  {
    name: "blog",
    path: "/blogg",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/blog/index.vue")
  },
  {
    name: "book-tripid-step",
    path: "/boka/:tripid()/:step()",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/book/[tripid]/[step].vue")
  },
  {
    name: "bookcall",
    path: "/boka-samtal",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/bookcall.vue")
  },
  {
    name: "bookflight-tripid",
    path: "/boka-flyg/:tripid()",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/bookflight/[tripid].vue")
  },
  {
    name: "booking-confirmation-id",
    path: "/booking-confirmation/:id()",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/booking-confirmation/[id].vue")
  },
  {
    name: "booking-finish-ocr",
    path: "/booking-finish/:ocr()",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/booking-finish/[ocr].vue")
  },
  {
    name: "bookingfaq-ocr",
    path: "/boknings-faq/:ocr()",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/bookingfaq/[ocr].vue")
  },
  {
    name: "byebyeie",
    path: "/byebyeie",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/byebyeie.vue")
  },
  {
    name: "calendar",
    path: "/kalender",
    meta: indexmzQv580cwoMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/calendar/index.vue")
  },
  {
    name: "calendar-lastminute",
    path: "/kalender/sista-minuten",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/calendar/lastminute.vue")
  },
  {
    name: "campaign-name",
    path: "/kampanj/:name()",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/campaign/[name].vue")
  },
  {
    name: "campaign",
    path: "/kampanj",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/campaign/index.vue")
  },
  {
    name: "catalogue",
    path: "/katalog",
    meta: catalogueRdIMytopr5Meta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/catalogue.vue")
  },
  {
    name: "category-slug",
    path: "/kategori/:slug()",
    meta: _91slug_93moXUMlBaU2Meta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/category/[slug].vue")
  },
  {
    name: "competition-slug",
    path: "/tavling/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/competition/[slug].vue")
  },
  {
    name: "complaint",
    path: "/reklamation",
    meta: complaintIRa0XBmJG5Meta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/complaint.vue")
  },
  {
    name: "destination-slug-tab",
    path: "/destination/:slug()/:tab()",
    meta: _91tab_93wwIUy3JbrsMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/destination/[slug]/[tab].vue")
  },
  {
    name: "dinbokning-aktuell",
    path: "/dinbokning-aktuell",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/dinbokning-aktuell.vue")
  },
  {
    name: "event-slug",
    path: "/event/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/event/[slug].vue")
  },
  {
    name: "event",
    path: "/event",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/event/index.vue")
  },
  {
    name: "faq",
    path: "/faq",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/faq.vue")
  },
  {
    name: "fn-id",
    path: "/fn/:id()",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/fn/[id].vue")
  },
  {
    name: "giftcard-id",
    path: "/presentkort/:id()",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/giftcard/[id].vue")
  },
  {
    name: "giftcard",
    path: "/presentkort",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/giftcard/index.vue")
  },
  {
    name: "hotels-name",
    path: "/hotell/:name()",
    meta: _91name_934FUURTHQvSMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/hotels/[name].vue")
  },
  {
    name: "hotels",
    path: "/hotell",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/hotels/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/index.vue")
  },
  {
    name: "info-slug",
    path: "/info/:slug()",
    meta: _91slug_93e60eHiUMMRMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/info/[slug].vue")
  },
  {
    name: "info-about-tab",
    path: "/info/om/:tab()",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/about/[tab].vue")
  },
  {
    name: "info-connections-tab",
    path: "/info/anslutning/:tab()",
    meta: _91tab_93B0WEd3tVnHMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/connections/[tab].vue")
  },
  {
    name: "info-grouptravel",
    path: "/info/gruppresor",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/grouptravel.vue")
  },
  {
    name: "info",
    path: "/info",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/index.vue")
  },
  {
    name: "info-lectures-tab",
    path: "/info/forelasningar/:tab()",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/lectures/[tab].vue")
  },
  {
    name: "info-reviews",
    path: "/info/reviews",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/reviews.vue")
  },
  {
    name: "info-solo-tab",
    path: "/info/solo/:tab()",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/solo/[tab].vue")
  },
  {
    name: "lastminute",
    path: "/sista-minuten-erbjudanden",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/lastminute.vue")
  },
  {
    name: "map",
    path: "/karta",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/map.vue")
  },
  {
    name: "mytrip-tab",
    path: "/dinresa/:tab()",
    meta: _91tab_93JFYpyAEIXtMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/mytrip/[tab].vue")
  },
  {
    name: "mytrip-dinbokning",
    path: "/mytrip/dinbokning",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/mytrip/dinbokning.vue")
  },
  {
    name: "newsletter",
    path: "/nyhetsbrev",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/newsletter.vue")
  },
  {
    name: "offline",
    path: "/offline",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/offline.vue")
  },
  {
    name: "omdome-id",
    path: "/omdome/:id()",
    meta: _91id_93gjUwSRSHOaMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/omdome/[id].vue")
  },
  {
    name: "payment-id",
    path: "/payment/:id()",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/payment/[id].vue")
  },
  {
    name: "payment-failed",
    path: "/payment/failed",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/payment/failed.vue")
  },
  {
    name: "review",
    path: "/utvardera-resa",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/review/index.vue")
  },
  {
    name: "satisfactionstatus-triptypeid-paxid",
    path: "/nojdhet-status/:triptypeid()/:paxid()",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/applications/rolfsbuss-web/pages/satisfactionstatus/[triptypeid]/[paxid].vue")
  },
  {
    name: "search",
    path: "/sok",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/search.vue")
  },
  {
    name: "shipinfo-name",
    path: "/fartyg/:name()",
    meta: _91name_93m02FxasUtmMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/shipinfo/[name].vue")
  },
  {
    name: "titinerary-slug",
    path: "/dagprogram/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/titinerary/[slug].vue")
  },
  {
    name: "tourleader-id-slug",
    path: "/reseledare/:id()/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/tourleader/[id]/[slug].vue")
  },
  {
    name: "tourleader",
    path: "/reseledare",
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/tourleader/index.vue")
  },
  {
    name: "verification-done",
    path: "/verification-done",
    meta: verification_45doneisG3nlnX1DMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-08-0724/rtg-monorepo/src/layers/web/pages/verification-done.vue")
  }
]